import {ruleGenerator} from '@/components/form/runtime/components/rule'
import _ from 'lodash'
import moment from 'moment'
const publicMixin = {
  mixins: [ruleGenerator],
  props: ['data', 'column', 'component', 'width', 'form', 'report', 'allComponent'],
  inject: ['eventBus'],
  data () {
    return {
      value: '',
      edit: false,
      showTooltip: false,
      error: '',
      editColumn: {},
      componentRules: [],
      expressions: [],
      watchColumnId: '',
      unWatch: null,
      params: '',
      copyData: {},
      isCancel: false,
      controlHeight: '100%',
      controlMinHeight: '36px'
    }
  },
  created () {
    this.value = this.data[this.column.id]
    this.editColumn = JSON.parse(this.report.editColumns).find(e => e.id === this.column.id)
    // 这个东西，复制出来监听用，不能直接监听data，要不然会走贼多次。。。。。。。。this都乱了。
    this.copyData = _.cloneDeep(this.data)
    this.getAllExpression(this.allComponent)
  },
  methods: {
    update (value = undefined) {
      // 为了处理那种unll和undefined
      let disposeValue = this.value ? this.value : ''
      this.updateDataValue({id: this.column.id, value: value === undefined ? disposeValue : value})
      this.$nextTick(async () => { await this.saveData() })
    },
    openInput () {
      try {
        this.eventBus.$emit('report.beforeEditColumn', {data: this.data, column: this.column, component: this.component, allComponent: this.allComponent})
      } catch(e) {
        console.log(e)
        return null
      }
      if (!this.component.properties.readonly && !this.component.properties.hidden) {
        this.edit = true
        this.$nextTick(() => {
          this.$refs.input.focus()
          if (this.component.properties.multiple && this.component.properties.search && this.$refs.rcComboboxMultipeInput) {
            this.$refs.rcComboboxMultipeInput.focus()
          }
        })
      }
    },
    updateValue () {
      if (this.isCancel) {
        this.isCancel = false
        return false
      }
      let error = this.validate()
      this.error = error
      // 如果值相同这不需要走saveData
      if (this.value === this.data[this.column.id] && !error) {
        this.edit = false
        this.error = ''
        return false
      }
      if (this.component.componentType === 'rc-numeric') {
        // 如果小数点是最后一位的话取消小数点。
        let value = parseFloat(this.value)
        this.value = isNaN(parseFloat(value)) ? '' : value
      }
      if (!error) {
        this.error = ''
        this.edit = false
        this.update()
      }
    },
    getShowTooltip (newWidth = undefined) {
      let control = this.$refs.control
      if (control && typeof this.value === 'string') {
        let width = newWidth || (control.offsetWidth - 5)
        let fontWidth = 0
        this.value.split('').forEach(v => {
          // eslint-disable-next-line
          fontWidth += /^[\x00-\xff]/.test(v) ? 8 : 15
        })
        this.showTooltip = fontWidth > width
      } else {
        this.showTooltip = false
      }
    },
    // 取消不需要走保存
    cancel () {
      this.isCancel = true
      this.edit = false
      this.error = ''
      this.updateDataValue({id: this.column.id, value: this.data[this.column.id]})
      this.value = this.data[this.column.id]
    },
    validate () {
      if (this.componentRules && this.componentRules.length > 0) {
        let error = ''
        for (let i = 0; i < this.componentRules.length; i++) {
          if (error) { break }
          error = this.disposeValidateType(this.componentRules[i])
        }
        return error
      } else {
        return ''
      }
    },
    disposeValidateType (rule) {
      // 必填校验
      if (rule.required) {
        return this.value ? '' : rule.message
      } else if (rule.pattern) { // 正则校验
        return rule.pattern.test(this.value) ? '' : rule.message
      } else if (rule.validator && typeof rule.validator === 'function') {
        let error = ''
        rule.validator(rule, this.value, e => {
          if (e) {
            error = e.message
          }
        })
        return error
      }
    },
    async saveData () {
      let data = this.build()
      await this.$axios.post(`/form-api/runtime/${this.form.form.form.id}/saveData`, data)
    },
    build () {
      let data = {}
      for (let key in this.data) {
        if (key === 'Id') {
          data.id = this.data[key]
        } else if (key !== 'checked') {
          let column = this.report.columns.find(c => c.id === key)
          // 不包含计算的列
          if (column && !column.summary) {
            let columnId = column.expressionText && column.expressionText.match(/\$\{(.+?)\}/g) && column.expressionText.match(/\$\{(.+?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[0]
            if (columnId) {
              data[columnId] = this.data[key]
            }
          }
        }
      }
      data.dataState = 'update'
      return data
    },
    getAllExpression (allComponents) {
      allComponents = _.cloneDeep(allComponents)
      // 过滤所有可选控件
      let components = allComponents.filter(m => m.archive.columnId && (m.componentType === 'rc-numeric' || m.componentType === 'rc-input' || m.componentType === 'rc-combobox' || m.componentType === 'rc-date' || m.componentType === 'rc-textarea'))
      // 过滤出当前选了的列所对应的控件
      components = components.filter(c => !!JSON.parse(this.report.editColumns).find(m => m.componentId === c.id))
      // 过滤出包含计算的控件
      components.forEach(c => { c.properties = typeof c.properties !== 'object' ? JSON.parse(c.properties) : c.properties })
      components = components.filter(c => c.archive && c.archive.columnId && c.properties && c.properties.calculate && c.properties.calculate.enable)
      let editColumns = JSON.parse(this.report.editColumns)
      components = components.map(m => {
        let findColumn = editColumns.find(e => e.columnId === m.archive.columnId)
        return {
          // 归档id
          id: m.archive.columnId,
          // 公式
          expressionText: m.properties.calculate.calculationPanelData.expression,
          // 列Id
          reportColumnId: findColumn ? findColumn.id : '',
          columnIds: this.getColumnIds(m.properties.calculate.calculationPanelData.expression) || []
        }
      })
      // 监听这些涉及计算的控件的值
      this.unWatch = this.$watch(() => {
        let watchObj = []
        components.forEach(c => {
          if (c && c.columnIds && c.columnIds.length > 0) {
            let columnIds = c.columnIds.map(c => c.columnId)
            columnIds.forEach(f => {
              let column = editColumns.find(e => e.columnId === f || e.combobxShowColumnId === f)
              column && this.copyData.hasOwnProperty(column.id) && watchObj.push({
                // 需要修改的列的id
                id: column.id,
                // 修改之后的值
                value: this.copyData[column.id],
                // 归档id
                columnId: c.id
              })
            })
          }
        })
        return watchObj
      }, _.debounce(async (newValue, oldValue) => {
        await this.getCalValue(_.cloneDeep(newValue), _.cloneDeep(oldValue), components).then(res => {
          // 遍历赋值
          if (res && res.length) {
            res.forEach(colv => {
              if (colv) {
                // 如果这个列包含计算。则不修改
                let column = this.report.columns.find(c => c.id === colv.id)
                if (!column.summary) {
                  this.updateDataValue({id: colv.id, value: colv.value})
                }
              }
            })
            this.$nextTick(async () => {
              await this.saveData()
            })
          }
        })
      }, 200), {deep: true})
    },
    // 从公式获取 id 组
    getColumnIds (expression) {
      let result = []
      let reg = /\$\{(.+?)\}/g
      if (typeof expression !== 'number') {
        expression.match(reg) && expression.match(reg).map(m => {
          let columnId = m.replace(/[${}]/g, '').split(',')[0].split('+')[0]
          let relationId = m.replace(/[${}]/g, '').split(',')[0].split('+')[1]
          let type = m.replace(/[${}]/g, '').split(',')[2]
          if (type !== 'sql') {
            if (relationId === 'undefined') {
              relationId = undefined
            }
            if (!result.find(m => m.columnId === columnId && m.relationId === relationId)) {
              result.push({columnId, relationId})
            }
          }
        })
      }
      return result
    },
    // value：所有监听之后修改的值，
    // components：所有需要监听的控件
    async getCalValue (value, oldValue, components) {
      return new Promise(async resolve => {
        let copyValue = []
        if (oldValue && oldValue.length > 0) {
          copyValue = value.filter(v => {
            let a = oldValue.find(x => x.id === v.id)
            return a && a.value !== v.value
          })
        } else {
          copyValue = value || []
        }
        if (copyValue && copyValue.length > 0) {
          await Promise.all(copyValue.map(c => this.traversalCalc(c, components))).then(res => {
            resolve(res)
          })
        } else {
          resolve()
        }
      })
    },
    traversalCalc (value, components) {
      return new Promise(async resolve => {
        let component = components.find(c => c.id === value.columnId)
        // 只有当前公式中所有涉及的归档id都在列中才能执行计算
        if (component) {
          let variables = {}
          component.columnIds.forEach(c => {
            let column = JSON.parse(this.report.editColumns).find(r => r.columnId === c.columnId || r.combobxShowColumnId === c.columnId)
            if (column) {
              // 数据源下拉框
              if (column.combobxShowColumnId) {
                // 如果包含下拉框id
                if (component.expressionText.includes(column.columnId)) {
                  variables[column.columnId] = this.data[column.combobxColumnId]
                } else if (component.expressionText.includes(column.combobxShowColumnId)) { // 下拉框名字
                  variables[column.combobxShowColumnId] = this.data[column.id]
                }
              } else {
                variables[column.columnId] = this.data[column.id]
              }
            }
          })
          await this.calc(component.expressionText, variables).then(res => {
            resolve({id: component.reportColumnId, value: res})
          })
        } else { resolve() }
      })
    },
    calc (expression, dataMap) {
      return new Promise(async resolve => {
        await this.$axios.post('/form-api/runtime/calc', {'formula': expression, 'variables': dataMap}, {
          transformResponse: [function (data) {
            // 处理数字长度过长导致精度丢失问题
            return typeof data === 'number' ? data.request.response : data
          }]}).then(res => resolve(res.data))
      })
    },
    // 修改data的值，并且修改copyData的值触发当前控件的监听
    updateDataValue (data) {
      this.$emit('updateColumn', data, this.data)
      this.$set(this.copyData, data.id, data.value)
    },
    getDisplayFormatConditionResult (type, data, condition) {
      let flag = false
      if (['>=', '<=', '>', '<'].some(n => type.includes(n))) {
        data = Number(data)
        condition = Number(condition)
      }
      switch (type) {
        case '==' :
          flag = data === condition
          break
        case '>=' :
          flag = data >= condition
          break
        case '<=' :
          flag = data <= condition
          break
        case '<' :
          flag = data < condition
          break
        case '>' :
          flag = data > condition
          break
        case '!=' :
          // 字符串数字与数字对比不能用全等。
          // eslint-disable-next-line
          flag = data != condition
          break
        case 'include' :
          flag = data.includes(condition)
          break
        case 'exclude' :
          flag = !data.includes(condition)
          break
      }
      return flag
    },
    handleDecimalDigits (roundWay, data, decimalDigits) {
      data = Number(data)
      switch (roundWay) {
        case 'rounding':
          data = _.round(data, decimalDigits)
          break
        case 'ceil':
          data = _.ceil(data, decimalDigits)
          break
        case 'floor':
          data = _.floor(data, decimalDigits)
          break
        default:
          data = data.toFixed(decimalDigits)
      }
      return data
    },
    setControlHeight () {
      let control = this.$refs.control
      this.controlHeight = control ? (control.offsetHeight + 'px') : '100%'
    },
    // 数字转千分位
    comdify (n) {
      // 负数时，负号直接拼接
      let plusMinusSign = ''
      if (n.startsWith('-')) {
        plusMinusSign = '-'
        n = n.slice(1)
      }
      let re = /\d{1,3}(?=(\d{3})+$)/g
      let afterComdifyNumber = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
        return s1.replace(re, '$&,') + s2
      })
      return plusMinusSign + afterComdifyNumber
    },
    // 将文本中的http开头的网址,变为可直接点击的地址
    findHttpText (data) {
      let httpReg = new RegExp('(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]', 'g')
      if (httpReg.test(data)) {
        return data.replace(httpReg, `<a href="$&" target="_blank">$&</a>`)
      } else {
        return data
      }
    },
    // 指定列打开表单
    openForm () {
      if (this.report.clickColumn.appointColumn === this.column.id) {
        this.$emit('doColumnAction')
      }
    }
  },
  mounted () {
    this.getShowTooltip()
    this.$nextTick(() => {
      let control = this.$refs.control
      this.controlHeight = control ? (control.offsetHeight + 'px') : '100%'
    })
  },
  watch: {
    edit (val) {
      !val && this.getShowTooltip()
      if (val) {
        // 计算文本框的高度
        let control = this.$refs.control
        this.controlHeight = control ? (control.offsetHeight + 'px') : '100%'
      }
    },
    width (val) {
      let control = this.$refs.control
      this.controlHeight = control ? (control.offsetHeight + 'px') : '100%'
      this.getShowTooltip(val)
    },
    component: {
      handler (val) {
        if (val && Object.keys(val).length > 0 && val.properties) {
          let properties = val.properties
          this.component.properties = typeof properties === 'object' ? properties : JSON.parse(properties)
          this.initProperties = true
          this.componentRules = this.buildRule()
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy () {
    // 销毁监听
    this.unWatch()
  },
  computed: {
    formatter () {
      return (data, type) => {
        if (this.copyData && Object.keys(this.copyData).length) {
          let col = this.report.columns.find(m => m.id === this.column.id)
          let displayFormats = []
          let dataFormat = {}
          // 处理数据为boolean类型
          if (typeof data === 'boolean') {
            data = data + ''
          }
          if (data || data === 0) {
            // 判断是不是日期 并且日期的值是否存在
            if (col.columnType === 'bit') {
              // 查询的结果为布尔类型的时候, 将值转成 String 类型
              data = data + ''
            } else if (col.columnType === 'html' || col.columnType === 'HTML') {
              // 查询的结果为html的时候, 将值转成 富文本内容查看
              // 将br标签替换成空格
              data = data.replace(/<br>/, ' ')
              // 替换所有标签
              data = data.replace(/<[^>]+>/g, '')
              // 删除所有的空格标签
              data = data.replace(/&nbsp;/g, '')
            }
            if (col.useThousandth) {
              // 开启了千分位的转千分位
              data = data + ''
              data = this.comdify(data)
            }
            // 基本格式的数据处理
            if (col.format && col.format.dataFormat) {
              dataFormat = typeof (col.format.dataFormat) === 'string' ? JSON.parse(col.format.dataFormat) : col.format.dataFormat
              if (dataFormat.dataType === 'decimal' || dataFormat.dataType === 'int') {
                data = this.handleDecimalDigits(dataFormat.roundWay, data, dataFormat.decimalDigits)
              } else if (dataFormat.dataType === 'percent') {
                data = this.handleDecimalDigits(dataFormat.roundWay, data, dataFormat.decimalDigits) * 100 + '%'
              } else if (dataFormat.dataType === 'date') {
                if (dataFormat.dataformat === 'DA') {
                  return moment(data).format('YYYY-MM-DD')
                } else if (dataFormat.dataformat === 'DB') {
                  return moment(data).format('YYYY年MM月DD日')
                } else if (dataFormat.dataformat === 'DC') {
                  return moment(data).format('YYYY年MM月')
                } else if (dataFormat.dataformat === 'DD') {
                  return `${moment(data).year()}年第${moment(data).quarter()}季度`
                } else if (dataFormat.dataformat === 'DE') {
                  let halfYear = moment(data).quarter() === 1 || moment(data).quarter() === 2 ? '上半年' : '下半年'
                  return `${moment(data).year()}年${halfYear}`
                } else if (dataFormat.dataformat === 'DF') {
                  return moment(data).format('MM月DD日')
                } else if (dataFormat.dataformat === 'DG') {
                  return moment(data).format('MM月')
                } else if (dataFormat.dataformat === 'DH') {
                  let arr = ['日', '一', '二', '三', '四', '五', '六']
                  return `周${arr[moment(data).format('d')]}`
                }
              } else {
                if (col.columnType === 'datetime') {
                  data = data.includes(',') ? data : moment(data).format('YYYY-MM-DD HH:mm:ss')
                } else if (col.columnType === 'date') {
                  data = data.includes(',') ? data : moment(data).format('YYYY-MM-DD')
                }
              }
            }

            // 自定义显示的数据处理
            if (col.format && col.format.displayFormats) {
              displayFormats = typeof (col.format.displayFormats) === 'string' ? JSON.parse(col.format.displayFormats) : col.format.displayFormats
              displayFormats.forEach(el => {
                if (el.value && el.condition) {
                  let result = this.getDisplayFormatConditionResult(el.type, data, el.condition)
                  if (result) {
                    data = el.value
                  }
                }
              })
            }

            // 处理http文字 el-tooltip中的不处理
            if (type !== 'content') {
              data = this.findHttpText(data)
            }

            return data
          }
        }
      }
    }
  }
}
export default publicMixin



// WEBPACK FOOTER //
// ./src/components/report/runtime/reportColumnEdit/mixin.js